export default __webpack_public_path__ + "static/media/no-wish.34366853.svg";